module.exports = [
	{
		"id": 31,
		"Jahr": 2000,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 105,
		"SozialhilfeQuote": 3.9
	},
	{
		"id": 32,
		"Jahr": 2001,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 96,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 33,
		"Jahr": 2002,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 122,
		"SozialhilfeQuote": 4.4
	},
	{
		"id": 34,
		"Jahr": 2003,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 151,
		"SozialhilfeQuote": 5.4
	},
	{
		"id": 35,
		"Jahr": 2004,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 140,
		"SozialhilfeQuote": 5.1
	},
	{
		"id": 36,
		"Jahr": 2005,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 5.1
	},
	{
		"id": 37,
		"Jahr": 2006,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 102,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 38,
		"Jahr": 2007,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 95,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 39,
		"Jahr": 2008,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 58,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 40,
		"Jahr": 2009,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 58,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 41,
		"Jahr": 2010,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 53,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 42,
		"Jahr": 2011,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 56,
		"SozialhilfeQuote": 2
	},
	{
		"id": 43,
		"Jahr": 2012,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 73,
		"SozialhilfeQuote": 2.5
	},
	{
		"id": 44,
		"Jahr": 2013,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 60,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 45,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"SozialhilfeBeziehende": 63,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 46,
		"Jahr": 2000,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 20,
		"SozialhilfeQuote": 3.4
	},
	{
		"id": 47,
		"Jahr": 2001,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 19,
		"SozialhilfeQuote": 3.2
	},
	{
		"id": 48,
		"Jahr": 2002,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 21,
		"SozialhilfeQuote": 3.6
	},
	{
		"id": 49,
		"Jahr": 2003,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 10,
		"SozialhilfeQuote": 1.7
	},
	{
		"id": 50,
		"Jahr": 2004,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 12,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 51,
		"Jahr": 2005,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 15,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 52,
		"Jahr": 2006,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 10,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 53,
		"Jahr": 2007,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 8,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 54,
		"Jahr": 2008,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 12,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 55,
		"Jahr": 2009,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 7,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 56,
		"Jahr": 2010,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 12,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 57,
		"Jahr": 2011,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 8,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 58,
		"Jahr": 2012,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 10,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 59,
		"Jahr": 2013,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 6,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 60,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"SozialhilfeBeziehende": 11,
		"SozialhilfeQuote": 2
	},
	{
		"id": 61,
		"Jahr": 2000,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 8,
		"SozialhilfeQuote": 0.5
	},
	{
		"id": 62,
		"Jahr": 2001,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 6,
		"SozialhilfeQuote": 0.4
	},
	{
		"id": 63,
		"Jahr": 2002,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 10,
		"SozialhilfeQuote": 0.6
	},
	{
		"id": 64,
		"Jahr": 2003,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 10,
		"SozialhilfeQuote": 0.6
	},
	{
		"id": 65,
		"Jahr": 2004,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 18,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 66,
		"Jahr": 2005,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 19,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 67,
		"Jahr": 2006,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 161,
		"SozialhilfeQuote": 9.9
	},
	{
		"id": 68,
		"Jahr": 2007,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 172,
		"SozialhilfeQuote": 10.7
	},
	{
		"id": 69,
		"Jahr": 2008,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 144,
		"SozialhilfeQuote": 8.9
	},
	{
		"id": 70,
		"Jahr": 2009,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 128,
		"SozialhilfeQuote": 8
	},
	{
		"id": 71,
		"Jahr": 2010,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 124,
		"SozialhilfeQuote": 7.8
	},
	{
		"id": 72,
		"Jahr": 2011,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 113,
		"SozialhilfeQuote": 7.2
	},
	{
		"id": 73,
		"Jahr": 2012,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 110,
		"SozialhilfeQuote": 7
	},
	{
		"id": 74,
		"Jahr": 2013,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 115,
		"SozialhilfeQuote": 7.4
	},
	{
		"id": 75,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"SozialhilfeBeziehende": 119,
		"SozialhilfeQuote": 7.5
	},
	{
		"id": 76,
		"Jahr": 2000,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 74,
		"SozialhilfeQuote": 3.9
	},
	{
		"id": 77,
		"Jahr": 2001,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 55,
		"SozialhilfeQuote": 2.9
	},
	{
		"id": 78,
		"Jahr": 2002,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 61,
		"SozialhilfeQuote": 3.2
	},
	{
		"id": 79,
		"Jahr": 2003,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 64,
		"SozialhilfeQuote": 4.4
	},
	{
		"id": 80,
		"Jahr": 2004,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 72,
		"SozialhilfeQuote": 6.5
	},
	{
		"id": 81,
		"Jahr": 2005,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 58,
		"SozialhilfeQuote": 5.7
	},
	{
		"id": 82,
		"Jahr": 2006,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 142,
		"SozialhilfeQuote": 13.7
	},
	{
		"id": 83,
		"Jahr": 2007,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 143,
		"SozialhilfeQuote": 13.4
	},
	{
		"id": 84,
		"Jahr": 2008,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 138,
		"SozialhilfeQuote": 13.3
	},
	{
		"id": 85,
		"Jahr": 2009,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 124,
		"SozialhilfeQuote": 12.1
	},
	{
		"id": 86,
		"Jahr": 2010,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 13.9
	},
	{
		"id": 87,
		"Jahr": 2011,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 143,
		"SozialhilfeQuote": 15
	},
	{
		"id": 88,
		"Jahr": 2012,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 127,
		"SozialhilfeQuote": 13.4
	},
	{
		"id": 89,
		"Jahr": 2013,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 120,
		"SozialhilfeQuote": 12.6
	},
	{
		"id": 90,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"SozialhilfeBeziehende": 119,
		"SozialhilfeQuote": 12.6
	},
	{
		"id": 106,
		"Jahr": 2000,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 442,
		"SozialhilfeQuote": 2.9
	},
	{
		"id": 107,
		"Jahr": 2001,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 440,
		"SozialhilfeQuote": 2.9
	},
	{
		"id": 108,
		"Jahr": 2002,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 425,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 109,
		"Jahr": 2003,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 468,
		"SozialhilfeQuote": 3.2
	},
	{
		"id": 110,
		"Jahr": 2004,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 569,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 111,
		"Jahr": 2005,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 573,
		"SozialhilfeQuote": 3.9
	},
	{
		"id": 112,
		"Jahr": 2006,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 579,
		"SozialhilfeQuote": 3.9
	},
	{
		"id": 113,
		"Jahr": 2007,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 501,
		"SozialhilfeQuote": 3.3
	},
	{
		"id": 114,
		"Jahr": 2008,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 431,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 115,
		"Jahr": 2009,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 403,
		"SozialhilfeQuote": 2.6
	},
	{
		"id": 116,
		"Jahr": 2010,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 405,
		"SozialhilfeQuote": 2.6
	},
	{
		"id": 117,
		"Jahr": 2011,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 420,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 118,
		"Jahr": 2012,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 425,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 119,
		"Jahr": 2013,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 437,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 120,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"SozialhilfeBeziehende": 418,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 121,
		"Jahr": 2000,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 130,
		"SozialhilfeQuote": 2.9
	},
	{
		"id": 122,
		"Jahr": 2001,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 145,
		"SozialhilfeQuote": 3.2
	},
	{
		"id": 123,
		"Jahr": 2002,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 168,
		"SozialhilfeQuote": 3.6
	},
	{
		"id": 124,
		"Jahr": 2003,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 194,
		"SozialhilfeQuote": 4.1
	},
	{
		"id": 125,
		"Jahr": 2004,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 228,
		"SozialhilfeQuote": 4.9
	},
	{
		"id": 126,
		"Jahr": 2005,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 249,
		"SozialhilfeQuote": 5.2
	},
	{
		"id": 127,
		"Jahr": 2006,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 217,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 128,
		"Jahr": 2007,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 233,
		"SozialhilfeQuote": 4.6
	},
	{
		"id": 129,
		"Jahr": 2008,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 244,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 130,
		"Jahr": 2009,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 222,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 131,
		"Jahr": 2010,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 224,
		"SozialhilfeQuote": 4.3
	},
	{
		"id": 132,
		"Jahr": 2011,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 239,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 133,
		"Jahr": 2012,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 254,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 134,
		"Jahr": 2013,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 305,
		"SozialhilfeQuote": 5.4
	},
	{
		"id": 135,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"SozialhilfeBeziehende": 327,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 136,
		"Jahr": 2000,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 187,
		"SozialhilfeQuote": 2.5
	},
	{
		"id": 137,
		"Jahr": 2001,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 167,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 138,
		"Jahr": 2002,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 206,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 139,
		"Jahr": 2003,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 212,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 140,
		"Jahr": 2004,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 219,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 141,
		"Jahr": 2005,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 238,
		"SozialhilfeQuote": 3
	},
	{
		"id": 142,
		"Jahr": 2006,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 231,
		"SozialhilfeQuote": 3
	},
	{
		"id": 143,
		"Jahr": 2007,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 210,
		"SozialhilfeQuote": 2.6
	},
	{
		"id": 144,
		"Jahr": 2008,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 223,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 145,
		"Jahr": 2009,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 201,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 146,
		"Jahr": 2010,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 197,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 147,
		"Jahr": 2011,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 188,
		"SozialhilfeQuote": 2.3
	},
	{
		"id": 148,
		"Jahr": 2012,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 177,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 149,
		"Jahr": 2013,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 180,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 150,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"SozialhilfeBeziehende": 181,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 166,
		"Jahr": 2000,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 810,
		"SozialhilfeQuote": 6.2
	},
	{
		"id": 167,
		"Jahr": 2001,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 733,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 168,
		"Jahr": 2002,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 771,
		"SozialhilfeQuote": 5.8
	},
	{
		"id": 169,
		"Jahr": 2003,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 843,
		"SozialhilfeQuote": 6.4
	},
	{
		"id": 170,
		"Jahr": 2004,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 966,
		"SozialhilfeQuote": 7.3
	},
	{
		"id": 171,
		"Jahr": 2005,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 992,
		"SozialhilfeQuote": 7.2
	},
	{
		"id": 172,
		"Jahr": 2006,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 961,
		"SozialhilfeQuote": 6.9
	},
	{
		"id": 173,
		"Jahr": 2007,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 861,
		"SozialhilfeQuote": 6
	},
	{
		"id": 174,
		"Jahr": 2008,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 713,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 175,
		"Jahr": 2009,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 614,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 176,
		"Jahr": 2010,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 542,
		"SozialhilfeQuote": 3.6
	},
	{
		"id": 177,
		"Jahr": 2011,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 539,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 178,
		"Jahr": 2012,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 509,
		"SozialhilfeQuote": 3.3
	},
	{
		"id": 179,
		"Jahr": 2013,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 547,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 180,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"SozialhilfeBeziehende": 523,
		"SozialhilfeQuote": 3.3
	},
	{
		"id": 181,
		"Jahr": 2000,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 471,
		"SozialhilfeQuote": 4.9
	},
	{
		"id": 182,
		"Jahr": 2001,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 436,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 183,
		"Jahr": 2002,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 422,
		"SozialhilfeQuote": 4.3
	},
	{
		"id": 184,
		"Jahr": 2003,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 515,
		"SozialhilfeQuote": 5.1
	},
	{
		"id": 185,
		"Jahr": 2004,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 584,
		"SozialhilfeQuote": 5.8
	},
	{
		"id": 186,
		"Jahr": 2005,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 593,
		"SozialhilfeQuote": 5.9
	},
	{
		"id": 187,
		"Jahr": 2006,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 604,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 188,
		"Jahr": 2007,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 559,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 189,
		"Jahr": 2008,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 556,
		"SozialhilfeQuote": 5.5
	},
	{
		"id": 190,
		"Jahr": 2009,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 474,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 191,
		"Jahr": 2010,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 463,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 192,
		"Jahr": 2011,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 470,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 193,
		"Jahr": 2012,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 466,
		"SozialhilfeQuote": 4.4
	},
	{
		"id": 194,
		"Jahr": 2013,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 475,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 195,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"SozialhilfeBeziehende": 466,
		"SozialhilfeQuote": 4.4
	},
	{
		"id": 196,
		"Jahr": 2000,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1372,
		"SozialhilfeQuote": 7.4
	},
	{
		"id": 197,
		"Jahr": 2001,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1228,
		"SozialhilfeQuote": 6.6
	},
	{
		"id": 198,
		"Jahr": 2002,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1344,
		"SozialhilfeQuote": 7.1
	},
	{
		"id": 199,
		"Jahr": 2003,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1506,
		"SozialhilfeQuote": 8
	},
	{
		"id": 200,
		"Jahr": 2004,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1716,
		"SozialhilfeQuote": 9.1
	},
	{
		"id": 201,
		"Jahr": 2005,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1808,
		"SozialhilfeQuote": 9.6
	},
	{
		"id": 202,
		"Jahr": 2006,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1634,
		"SozialhilfeQuote": 8.8
	},
	{
		"id": 203,
		"Jahr": 2007,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1496,
		"SozialhilfeQuote": 7.9
	},
	{
		"id": 204,
		"Jahr": 2008,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1391,
		"SozialhilfeQuote": 7.2
	},
	{
		"id": 205,
		"Jahr": 2009,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1335,
		"SozialhilfeQuote": 6.9
	},
	{
		"id": 206,
		"Jahr": 2010,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1163,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 207,
		"Jahr": 2011,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 1028,
		"SozialhilfeQuote": 5.3
	},
	{
		"id": 208,
		"Jahr": 2012,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 990,
		"SozialhilfeQuote": 5
	},
	{
		"id": 209,
		"Jahr": 2013,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 954,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 210,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"SozialhilfeBeziehende": 982,
		"SozialhilfeQuote": 4.9
	},
	{
		"id": 226,
		"Jahr": 2000,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 291,
		"SozialhilfeQuote": 8.4
	},
	{
		"id": 227,
		"Jahr": 2001,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 346,
		"SozialhilfeQuote": 10.2
	},
	{
		"id": 228,
		"Jahr": 2002,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 274,
		"SozialhilfeQuote": 8
	},
	{
		"id": 229,
		"Jahr": 2003,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 311,
		"SozialhilfeQuote": 9.3
	},
	{
		"id": 230,
		"Jahr": 2004,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 288,
		"SozialhilfeQuote": 8.6
	},
	{
		"id": 231,
		"Jahr": 2005,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 224,
		"SozialhilfeQuote": 6.5
	},
	{
		"id": 232,
		"Jahr": 2006,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 210,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 233,
		"Jahr": 2007,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 172,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 234,
		"Jahr": 2008,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 167,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 235,
		"Jahr": 2009,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 135,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 236,
		"Jahr": 2010,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 147,
		"SozialhilfeQuote": 3.7
	},
	{
		"id": 237,
		"Jahr": 2011,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 136,
		"SozialhilfeQuote": 3.4
	},
	{
		"id": 238,
		"Jahr": 2012,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 239,
		"Jahr": 2013,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 146,
		"SozialhilfeQuote": 3.7
	},
	{
		"id": 240,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"SozialhilfeBeziehende": 146,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 241,
		"Jahr": 2000,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 977,
		"SozialhilfeQuote": 11.1
	},
	{
		"id": 242,
		"Jahr": 2001,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 934,
		"SozialhilfeQuote": 10.4
	},
	{
		"id": 243,
		"Jahr": 2002,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1047,
		"SozialhilfeQuote": 11.5
	},
	{
		"id": 244,
		"Jahr": 2003,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1163,
		"SozialhilfeQuote": 12.9
	},
	{
		"id": 245,
		"Jahr": 2004,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1205,
		"SozialhilfeQuote": 13.4
	},
	{
		"id": 246,
		"Jahr": 2005,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1248,
		"SozialhilfeQuote": 13.7
	},
	{
		"id": 247,
		"Jahr": 2006,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1257,
		"SozialhilfeQuote": 13.9
	},
	{
		"id": 248,
		"Jahr": 2007,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1133,
		"SozialhilfeQuote": 12.2
	},
	{
		"id": 249,
		"Jahr": 2008,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1062,
		"SozialhilfeQuote": 11
	},
	{
		"id": 250,
		"Jahr": 2009,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 1016,
		"SozialhilfeQuote": 10.6
	},
	{
		"id": 251,
		"Jahr": 2010,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 978,
		"SozialhilfeQuote": 10.2
	},
	{
		"id": 252,
		"Jahr": 2011,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 945,
		"SozialhilfeQuote": 9.7
	},
	{
		"id": 253,
		"Jahr": 2012,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 911,
		"SozialhilfeQuote": 9.3
	},
	{
		"id": 254,
		"Jahr": 2013,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 913,
		"SozialhilfeQuote": 9.2
	},
	{
		"id": 255,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"SozialhilfeBeziehende": 876,
		"SozialhilfeQuote": 8.6
	},
	{
		"id": 256,
		"Jahr": 2000,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 1074,
		"SozialhilfeQuote": 9.2
	},
	{
		"id": 257,
		"Jahr": 2001,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 943,
		"SozialhilfeQuote": 8
	},
	{
		"id": 258,
		"Jahr": 2002,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 919,
		"SozialhilfeQuote": 7.8
	},
	{
		"id": 259,
		"Jahr": 2003,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 1094,
		"SozialhilfeQuote": 9.3
	},
	{
		"id": 260,
		"Jahr": 2004,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 1134,
		"SozialhilfeQuote": 9.6
	},
	{
		"id": 261,
		"Jahr": 2005,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 1196,
		"SozialhilfeQuote": 10.3
	},
	{
		"id": 262,
		"Jahr": 2006,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 1174,
		"SozialhilfeQuote": 10.3
	},
	{
		"id": 263,
		"Jahr": 2007,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 1168,
		"SozialhilfeQuote": 9.9
	},
	{
		"id": 264,
		"Jahr": 2008,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 996,
		"SozialhilfeQuote": 8.3
	},
	{
		"id": 265,
		"Jahr": 2009,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 964,
		"SozialhilfeQuote": 8
	},
	{
		"id": 266,
		"Jahr": 2010,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 884,
		"SozialhilfeQuote": 7.3
	},
	{
		"id": 267,
		"Jahr": 2011,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 838,
		"SozialhilfeQuote": 7
	},
	{
		"id": 268,
		"Jahr": 2012,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 838,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 269,
		"Jahr": 2013,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 836,
		"SozialhilfeQuote": 6.7
	},
	{
		"id": 270,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"SozialhilfeBeziehende": 855,
		"SozialhilfeQuote": 6.9
	},
	{
		"id": 286,
		"Jahr": 2000,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 767,
		"SozialhilfeQuote": 9.1
	},
	{
		"id": 287,
		"Jahr": 2001,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 664,
		"SozialhilfeQuote": 7.8
	},
	{
		"id": 288,
		"Jahr": 2002,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 658,
		"SozialhilfeQuote": 7.6
	},
	{
		"id": 289,
		"Jahr": 2003,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 712,
		"SozialhilfeQuote": 8.3
	},
	{
		"id": 290,
		"Jahr": 2004,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 753,
		"SozialhilfeQuote": 8.5
	},
	{
		"id": 291,
		"Jahr": 2005,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 724,
		"SozialhilfeQuote": 8.2
	},
	{
		"id": 292,
		"Jahr": 2006,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 771,
		"SozialhilfeQuote": 8.7
	},
	{
		"id": 293,
		"Jahr": 2007,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 787,
		"SozialhilfeQuote": 8.7
	},
	{
		"id": 294,
		"Jahr": 2008,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 748,
		"SozialhilfeQuote": 8.1
	},
	{
		"id": 295,
		"Jahr": 2009,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 741,
		"SozialhilfeQuote": 8
	},
	{
		"id": 296,
		"Jahr": 2010,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 751,
		"SozialhilfeQuote": 8.1
	},
	{
		"id": 297,
		"Jahr": 2011,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 747,
		"SozialhilfeQuote": 8
	},
	{
		"id": 298,
		"Jahr": 2012,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 691,
		"SozialhilfeQuote": 7.4
	},
	{
		"id": 299,
		"Jahr": 2013,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 658,
		"SozialhilfeQuote": 7.1
	},
	{
		"id": 300,
		"Jahr": 2014,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"SozialhilfeBeziehende": 617,
		"SozialhilfeQuote": 6.7
	},
	{
		"id": 301,
		"Jahr": 2000,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 119,
		"SozialhilfeQuote": 7
	},
	{
		"id": 302,
		"Jahr": 2001,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 135,
		"SozialhilfeQuote": 7
	},
	{
		"id": 303,
		"Jahr": 2002,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 133,
		"SozialhilfeQuote": 5.9
	},
	{
		"id": 304,
		"Jahr": 2003,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 138,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 305,
		"Jahr": 2004,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 138,
		"SozialhilfeQuote": 5.7
	},
	{
		"id": 306,
		"Jahr": 2005,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 174,
		"SozialhilfeQuote": 7
	},
	{
		"id": 307,
		"Jahr": 2006,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 148,
		"SozialhilfeQuote": 5.5
	},
	{
		"id": 308,
		"Jahr": 2007,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 126,
		"SozialhilfeQuote": 4.6
	},
	{
		"id": 309,
		"Jahr": 2008,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 103,
		"SozialhilfeQuote": 3.7
	},
	{
		"id": 310,
		"Jahr": 2009,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 111,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 311,
		"Jahr": 2010,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 103,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 312,
		"Jahr": 2011,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 90,
		"SozialhilfeQuote": 3
	},
	{
		"id": 313,
		"Jahr": 2012,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 103,
		"SozialhilfeQuote": 3.2
	},
	{
		"id": 314,
		"Jahr": 2013,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 114,
		"SozialhilfeQuote": 3
	},
	{
		"id": 315,
		"Jahr": 2014,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"SozialhilfeBeziehende": 109,
		"SozialhilfeQuote": 2.5
	},
	{
		"id": 331,
		"Jahr": 2000,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 624,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 332,
		"Jahr": 2001,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 593,
		"SozialhilfeQuote": 3.3
	},
	{
		"id": 333,
		"Jahr": 2002,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 701,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 334,
		"Jahr": 2003,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 617,
		"SozialhilfeQuote": 3.4
	},
	{
		"id": 335,
		"Jahr": 2004,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 771,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 336,
		"Jahr": 2005,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 748,
		"SozialhilfeQuote": 4.1
	},
	{
		"id": 337,
		"Jahr": 2006,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 766,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 338,
		"Jahr": 2007,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 756,
		"SozialhilfeQuote": 4
	},
	{
		"id": 339,
		"Jahr": 2008,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 683,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 340,
		"Jahr": 2009,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 643,
		"SozialhilfeQuote": 3.2
	},
	{
		"id": 341,
		"Jahr": 2010,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 602,
		"SozialhilfeQuote": 3
	},
	{
		"id": 342,
		"Jahr": 2011,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 557,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 343,
		"Jahr": 2012,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 571,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 344,
		"Jahr": 2013,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 541,
		"SozialhilfeQuote": 2.6
	},
	{
		"id": 345,
		"Jahr": 2014,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"SozialhilfeBeziehende": 537,
		"SozialhilfeQuote": 2.6
	},
	{
		"id": 346,
		"Jahr": 2000,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 131,
		"SozialhilfeQuote": 1.5
	},
	{
		"id": 347,
		"Jahr": 2001,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 188,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 348,
		"Jahr": 2002,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 162,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 349,
		"Jahr": 2003,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 182,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 350,
		"Jahr": 2004,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 182,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 351,
		"Jahr": 2005,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 157,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 352,
		"Jahr": 2006,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 164,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 353,
		"Jahr": 2007,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 124,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 354,
		"Jahr": 2008,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 98,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 355,
		"Jahr": 2009,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 85,
		"SozialhilfeQuote": 0.9
	},
	{
		"id": 356,
		"Jahr": 2010,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 77,
		"SozialhilfeQuote": 0.8
	},
	{
		"id": 357,
		"Jahr": 2011,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 94,
		"SozialhilfeQuote": 1
	},
	{
		"id": 358,
		"Jahr": 2012,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 97,
		"SozialhilfeQuote": 1
	},
	{
		"id": 359,
		"Jahr": 2013,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 82,
		"SozialhilfeQuote": 0.8
	},
	{
		"id": 360,
		"Jahr": 2014,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"SozialhilfeBeziehende": 97,
		"SozialhilfeQuote": 1
	},
	{
		"id": 376,
		"Jahr": 2000,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 50,
		"SozialhilfeQuote": 0.8
	},
	{
		"id": 377,
		"Jahr": 2001,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 57,
		"SozialhilfeQuote": 0.9
	},
	{
		"id": 378,
		"Jahr": 2002,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 61,
		"SozialhilfeQuote": 0.9
	},
	{
		"id": 379,
		"Jahr": 2003,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 77,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 380,
		"Jahr": 2004,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 97,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 381,
		"Jahr": 2005,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 93,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 382,
		"Jahr": 2006,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 89,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 383,
		"Jahr": 2007,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 67,
		"SozialhilfeQuote": 1
	},
	{
		"id": 384,
		"Jahr": 2008,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 67,
		"SozialhilfeQuote": 0.9
	},
	{
		"id": 385,
		"Jahr": 2009,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 53,
		"SozialhilfeQuote": 0.7
	},
	{
		"id": 386,
		"Jahr": 2010,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 59,
		"SozialhilfeQuote": 0.8
	},
	{
		"id": 387,
		"Jahr": 2011,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 69,
		"SozialhilfeQuote": 0.9
	},
	{
		"id": 388,
		"Jahr": 2012,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 53,
		"SozialhilfeQuote": 0.7
	},
	{
		"id": 389,
		"Jahr": 2013,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 51,
		"SozialhilfeQuote": 0.7
	},
	{
		"id": 390,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"SozialhilfeBeziehende": 55,
		"SozialhilfeQuote": 0.7
	},
	{
		"id": 391,
		"Jahr": 2000,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 187,
		"SozialhilfeQuote": 2
	},
	{
		"id": 392,
		"Jahr": 2001,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 171,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 393,
		"Jahr": 2002,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 143,
		"SozialhilfeQuote": 1.6
	},
	{
		"id": 394,
		"Jahr": 2003,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 157,
		"SozialhilfeQuote": 1.7
	},
	{
		"id": 395,
		"Jahr": 2004,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 164,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 396,
		"Jahr": 2005,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 1.5
	},
	{
		"id": 397,
		"Jahr": 2006,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 144,
		"SozialhilfeQuote": 1.5
	},
	{
		"id": 398,
		"Jahr": 2007,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 127,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 399,
		"Jahr": 2008,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 117,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 400,
		"Jahr": 2009,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 100,
		"SozialhilfeQuote": 1
	},
	{
		"id": 401,
		"Jahr": 2010,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 102,
		"SozialhilfeQuote": 1
	},
	{
		"id": 402,
		"Jahr": 2011,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 108,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 403,
		"Jahr": 2012,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 112,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 404,
		"Jahr": 2013,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 108,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 405,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"SozialhilfeBeziehende": 107,
		"SozialhilfeQuote": 1
	},
	{
		"id": 406,
		"Jahr": 2000,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 150,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 407,
		"Jahr": 2001,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 139,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 408,
		"Jahr": 2002,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 409,
		"Jahr": 2003,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 134,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 410,
		"Jahr": 2004,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 130,
		"SozialhilfeQuote": 2
	},
	{
		"id": 411,
		"Jahr": 2005,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 161,
		"SozialhilfeQuote": 2.5
	},
	{
		"id": 412,
		"Jahr": 2006,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 149,
		"SozialhilfeQuote": 2.3
	},
	{
		"id": 413,
		"Jahr": 2007,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 144,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 414,
		"Jahr": 2008,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 122,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 415,
		"Jahr": 2009,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 127,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 416,
		"Jahr": 2010,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 116,
		"SozialhilfeQuote": 1.7
	},
	{
		"id": 417,
		"Jahr": 2011,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 107,
		"SozialhilfeQuote": 1.6
	},
	{
		"id": 418,
		"Jahr": 2012,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 98,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 419,
		"Jahr": 2013,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 100,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 420,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"SozialhilfeBeziehende": 100,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 421,
		"Jahr": 2000,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 114,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 422,
		"Jahr": 2001,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 110,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 423,
		"Jahr": 2002,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 118,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 424,
		"Jahr": 2003,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 122,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 425,
		"Jahr": 2004,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 126,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 426,
		"Jahr": 2005,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 158,
		"SozialhilfeQuote": 1.6
	},
	{
		"id": 427,
		"Jahr": 2006,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 428,
		"Jahr": 2007,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 130,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 429,
		"Jahr": 2008,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 107,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 430,
		"Jahr": 2009,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 118,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 431,
		"Jahr": 2010,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 132,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 432,
		"Jahr": 2011,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 123,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 433,
		"Jahr": 2012,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 135,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 434,
		"Jahr": 2013,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 150,
		"SozialhilfeQuote": 1.5
	},
	{
		"id": 435,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"SozialhilfeBeziehende": 163,
		"SozialhilfeQuote": 1.6
	},
	{
		"id": 451,
		"Jahr": 2000,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 104,
		"SozialhilfeQuote": 2.3
	},
	{
		"id": 452,
		"Jahr": 2001,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 97,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 453,
		"Jahr": 2002,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 126,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 454,
		"Jahr": 2003,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 126,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 455,
		"Jahr": 2004,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 137,
		"SozialhilfeQuote": 3
	},
	{
		"id": 456,
		"Jahr": 2005,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 139,
		"SozialhilfeQuote": 3.1
	},
	{
		"id": 457,
		"Jahr": 2006,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 92,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 458,
		"Jahr": 2007,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 94,
		"SozialhilfeQuote": 2.1
	},
	{
		"id": 459,
		"Jahr": 2008,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 85,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 460,
		"Jahr": 2009,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 66,
		"SozialhilfeQuote": 1.5
	},
	{
		"id": 461,
		"Jahr": 2010,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 49,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 462,
		"Jahr": 2011,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 64,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 463,
		"Jahr": 2012,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 54,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 464,
		"Jahr": 2013,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 68,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 465,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"SozialhilfeBeziehende": 58,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 466,
		"Jahr": 2000,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 113,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 467,
		"Jahr": 2001,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 120,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 468,
		"Jahr": 2002,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 112,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 469,
		"Jahr": 2003,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 116,
		"SozialhilfeQuote": 2.3
	},
	{
		"id": 470,
		"Jahr": 2004,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 118,
		"SozialhilfeQuote": 2.3
	},
	{
		"id": 471,
		"Jahr": 2005,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 123,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 472,
		"Jahr": 2006,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 119,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 473,
		"Jahr": 2007,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 118,
		"SozialhilfeQuote": 2.3
	},
	{
		"id": 474,
		"Jahr": 2008,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 91,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 475,
		"Jahr": 2009,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 92,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 476,
		"Jahr": 2010,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 90,
		"SozialhilfeQuote": 1.7
	},
	{
		"id": 477,
		"Jahr": 2011,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 118,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 478,
		"Jahr": 2012,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 106,
		"SozialhilfeQuote": 2
	},
	{
		"id": 479,
		"Jahr": 2013,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 108,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 480,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"SozialhilfeBeziehende": 117,
		"SozialhilfeQuote": 2
	},
	{
		"id": 481,
		"Jahr": 2000,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 73,
		"SozialhilfeQuote": 1.7
	},
	{
		"id": 482,
		"Jahr": 2001,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 55,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 483,
		"Jahr": 2002,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 46,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 484,
		"Jahr": 2003,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 61,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 485,
		"Jahr": 2004,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 80,
		"SozialhilfeQuote": 1.8
	},
	{
		"id": 486,
		"Jahr": 2005,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 86,
		"SozialhilfeQuote": 1.9
	},
	{
		"id": 487,
		"Jahr": 2006,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 70,
		"SozialhilfeQuote": 1.6
	},
	{
		"id": 488,
		"Jahr": 2007,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 60,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 489,
		"Jahr": 2008,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 54,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 490,
		"Jahr": 2009,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 61,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 491,
		"Jahr": 2010,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 54,
		"SozialhilfeQuote": 1.2
	},
	{
		"id": 492,
		"Jahr": 2011,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 49,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 493,
		"Jahr": 2012,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 52,
		"SozialhilfeQuote": 1.1
	},
	{
		"id": 494,
		"Jahr": 2013,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 63,
		"SozialhilfeQuote": 1.3
	},
	{
		"id": 495,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"SozialhilfeBeziehende": 67,
		"SozialhilfeQuote": 1.4
	},
	{
		"id": 511,
		"Jahr": 2000,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 633,
		"SozialhilfeQuote": 4
	},
	{
		"id": 512,
		"Jahr": 2001,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 578,
		"SozialhilfeQuote": 3.7
	},
	{
		"id": 513,
		"Jahr": 2002,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 649,
		"SozialhilfeQuote": 4.1
	},
	{
		"id": 514,
		"Jahr": 2003,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 690,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 515,
		"Jahr": 2004,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 812,
		"SozialhilfeQuote": 5
	},
	{
		"id": 516,
		"Jahr": 2005,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 939,
		"SozialhilfeQuote": 5.7
	},
	{
		"id": 517,
		"Jahr": 2006,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 926,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 518,
		"Jahr": 2007,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 826,
		"SozialhilfeQuote": 4.9
	},
	{
		"id": 519,
		"Jahr": 2008,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 739,
		"SozialhilfeQuote": 4.3
	},
	{
		"id": 520,
		"Jahr": 2009,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 718,
		"SozialhilfeQuote": 4.1
	},
	{
		"id": 521,
		"Jahr": 2010,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 678,
		"SozialhilfeQuote": 3.9
	},
	{
		"id": 522,
		"Jahr": 2011,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 680,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 523,
		"Jahr": 2012,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 711,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 524,
		"Jahr": 2013,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 712,
		"SozialhilfeQuote": 3.8
	},
	{
		"id": 525,
		"Jahr": 2014,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"SozialhilfeBeziehende": 672,
		"SozialhilfeQuote": 3.6
	},
	{
		"id": 526,
		"Jahr": 2000,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1707,
		"SozialhilfeQuote": 6.3
	},
	{
		"id": 527,
		"Jahr": 2001,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1676,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 528,
		"Jahr": 2002,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1724,
		"SozialhilfeQuote": 6.3
	},
	{
		"id": 529,
		"Jahr": 2003,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1833,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 530,
		"Jahr": 2004,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 2012,
		"SozialhilfeQuote": 7.4
	},
	{
		"id": 531,
		"Jahr": 2005,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 2164,
		"SozialhilfeQuote": 8
	},
	{
		"id": 532,
		"Jahr": 2006,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 2179,
		"SozialhilfeQuote": 7.9
	},
	{
		"id": 533,
		"Jahr": 2007,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 2022,
		"SozialhilfeQuote": 7.2
	},
	{
		"id": 534,
		"Jahr": 2008,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1913,
		"SozialhilfeQuote": 6.7
	},
	{
		"id": 535,
		"Jahr": 2009,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1853,
		"SozialhilfeQuote": 6.5
	},
	{
		"id": 536,
		"Jahr": 2010,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1823,
		"SozialhilfeQuote": 6.2
	},
	{
		"id": 537,
		"Jahr": 2011,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1800,
		"SozialhilfeQuote": 6
	},
	{
		"id": 538,
		"Jahr": 2012,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1743,
		"SozialhilfeQuote": 5.8
	},
	{
		"id": 539,
		"Jahr": 2013,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1679,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 540,
		"Jahr": 2014,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"SozialhilfeBeziehende": 1598,
		"SozialhilfeQuote": 5.3
	},
	{
		"id": 556,
		"Jahr": 2000,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 534,
		"SozialhilfeQuote": 2.7
	},
	{
		"id": 557,
		"Jahr": 2001,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 476,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 558,
		"Jahr": 2002,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 548,
		"SozialhilfeQuote": 2.8
	},
	{
		"id": 559,
		"Jahr": 2003,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 576,
		"SozialhilfeQuote": 2.9
	},
	{
		"id": 560,
		"Jahr": 2004,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 680,
		"SozialhilfeQuote": 3.4
	},
	{
		"id": 561,
		"Jahr": 2005,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 720,
		"SozialhilfeQuote": 3.6
	},
	{
		"id": 562,
		"Jahr": 2006,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 712,
		"SozialhilfeQuote": 3.5
	},
	{
		"id": 563,
		"Jahr": 2007,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 639,
		"SozialhilfeQuote": 3.1
	},
	{
		"id": 564,
		"Jahr": 2008,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 514,
		"SozialhilfeQuote": 2.5
	},
	{
		"id": 565,
		"Jahr": 2009,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 504,
		"SozialhilfeQuote": 2.4
	},
	{
		"id": 566,
		"Jahr": 2010,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 463,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 567,
		"Jahr": 2011,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 419,
		"SozialhilfeQuote": 2
	},
	{
		"id": 568,
		"Jahr": 2012,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 453,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 569,
		"Jahr": 2013,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 472,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 570,
		"Jahr": 2014,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"SozialhilfeBeziehende": 461,
		"SozialhilfeQuote": 2.2
	},
	{
		"id": 571,
		"Jahr": 2000,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 826,
		"SozialhilfeQuote": 6
	},
	{
		"id": 572,
		"Jahr": 2001,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 704,
		"SozialhilfeQuote": 5.1
	},
	{
		"id": 573,
		"Jahr": 2002,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 732,
		"SozialhilfeQuote": 5.3
	},
	{
		"id": 574,
		"Jahr": 2003,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 877,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 575,
		"Jahr": 2004,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 998,
		"SozialhilfeQuote": 7
	},
	{
		"id": 576,
		"Jahr": 2005,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 970,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 577,
		"Jahr": 2006,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 904,
		"SozialhilfeQuote": 6.4
	},
	{
		"id": 578,
		"Jahr": 2007,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 757,
		"SozialhilfeQuote": 5.3
	},
	{
		"id": 579,
		"Jahr": 2008,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 736,
		"SozialhilfeQuote": 5
	},
	{
		"id": 580,
		"Jahr": 2009,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 705,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 581,
		"Jahr": 2010,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 711,
		"SozialhilfeQuote": 4.7
	},
	{
		"id": 582,
		"Jahr": 2011,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 678,
		"SozialhilfeQuote": 4.5
	},
	{
		"id": 583,
		"Jahr": 2012,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 629,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 584,
		"Jahr": 2013,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 638,
		"SozialhilfeQuote": 4.2
	},
	{
		"id": 585,
		"Jahr": 2014,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"SozialhilfeBeziehende": 640,
		"SozialhilfeQuote": 4.3
	},
	{
		"id": 601,
		"Jahr": 2000,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 847,
		"SozialhilfeQuote": 4.8
	},
	{
		"id": 602,
		"Jahr": 2001,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 779,
		"SozialhilfeQuote": 4.4
	},
	{
		"id": 603,
		"Jahr": 2002,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 811,
		"SozialhilfeQuote": 4.6
	},
	{
		"id": 604,
		"Jahr": 2003,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1030,
		"SozialhilfeQuote": 5.8
	},
	{
		"id": 605,
		"Jahr": 2004,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1171,
		"SozialhilfeQuote": 6.6
	},
	{
		"id": 606,
		"Jahr": 2005,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1266,
		"SozialhilfeQuote": 7.1
	},
	{
		"id": 607,
		"Jahr": 2006,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1292,
		"SozialhilfeQuote": 7.3
	},
	{
		"id": 608,
		"Jahr": 2007,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1397,
		"SozialhilfeQuote": 7
	},
	{
		"id": 609,
		"Jahr": 2008,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1311,
		"SozialhilfeQuote": 6.2
	},
	{
		"id": 610,
		"Jahr": 2009,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1194,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 611,
		"Jahr": 2010,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1162,
		"SozialhilfeQuote": 5.3
	},
	{
		"id": 612,
		"Jahr": 2011,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1212,
		"SozialhilfeQuote": 5.2
	},
	{
		"id": 613,
		"Jahr": 2012,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1196,
		"SozialhilfeQuote": 5
	},
	{
		"id": 614,
		"Jahr": 2013,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1208,
		"SozialhilfeQuote": 5.1
	},
	{
		"id": 615,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"SozialhilfeBeziehende": 1256,
		"SozialhilfeQuote": 5.1
	},
	{
		"id": 616,
		"Jahr": 2000,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 858,
		"SozialhilfeQuote": 5.5
	},
	{
		"id": 617,
		"Jahr": 2001,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 791,
		"SozialhilfeQuote": 4.9
	},
	{
		"id": 618,
		"Jahr": 2002,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 768,
		"SozialhilfeQuote": 4.7
	},
	{
		"id": 619,
		"Jahr": 2003,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 940,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 620,
		"Jahr": 2004,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1098,
		"SozialhilfeQuote": 6.4
	},
	{
		"id": 621,
		"Jahr": 2005,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1186,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 622,
		"Jahr": 2006,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1250,
		"SozialhilfeQuote": 6.9
	},
	{
		"id": 623,
		"Jahr": 2007,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1207,
		"SozialhilfeQuote": 6.5
	},
	{
		"id": 624,
		"Jahr": 2008,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1143,
		"SozialhilfeQuote": 6.1
	},
	{
		"id": 625,
		"Jahr": 2009,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1123,
		"SozialhilfeQuote": 5.9
	},
	{
		"id": 626,
		"Jahr": 2010,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1072,
		"SozialhilfeQuote": 5.6
	},
	{
		"id": 627,
		"Jahr": 2011,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1050,
		"SozialhilfeQuote": 5.4
	},
	{
		"id": 628,
		"Jahr": 2012,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1028,
		"SozialhilfeQuote": 5.3
	},
	{
		"id": 629,
		"Jahr": 2013,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1024,
		"SozialhilfeQuote": 5.2
	},
	{
		"id": 630,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"SozialhilfeBeziehende": 1094,
		"SozialhilfeQuote": 5.5
	},
	{
		"id": 631,
		"Jahr": 2000,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1247,
		"SozialhilfeQuote": 7.5
	},
	{
		"id": 632,
		"Jahr": 2001,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1111,
		"SozialhilfeQuote": 6.6
	},
	{
		"id": 633,
		"Jahr": 2002,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1145,
		"SozialhilfeQuote": 6.5
	},
	{
		"id": 634,
		"Jahr": 2003,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1415,
		"SozialhilfeQuote": 7.8
	},
	{
		"id": 635,
		"Jahr": 2004,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1660,
		"SozialhilfeQuote": 9.1
	},
	{
		"id": 636,
		"Jahr": 2005,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1813,
		"SozialhilfeQuote": 9.8
	},
	{
		"id": 637,
		"Jahr": 2006,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1840,
		"SozialhilfeQuote": 9.7
	},
	{
		"id": 638,
		"Jahr": 2007,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1813,
		"SozialhilfeQuote": 9.2
	},
	{
		"id": 639,
		"Jahr": 2008,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1624,
		"SozialhilfeQuote": 8.2
	},
	{
		"id": 640,
		"Jahr": 2009,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1523,
		"SozialhilfeQuote": 7.6
	},
	{
		"id": 641,
		"Jahr": 2010,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1532,
		"SozialhilfeQuote": 7.5
	},
	{
		"id": 642,
		"Jahr": 2011,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1474,
		"SozialhilfeQuote": 7.1
	},
	{
		"id": 643,
		"Jahr": 2012,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1397,
		"SozialhilfeQuote": 6.4
	},
	{
		"id": 644,
		"Jahr": 2013,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1327,
		"SozialhilfeQuote": 5.9
	},
	{
		"id": 645,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"SozialhilfeBeziehende": 1365,
		"SozialhilfeQuote": 6
	},
	{
		"id": 661,
		"Jahr": 2000,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 473,
		"SozialhilfeQuote": 7.6
	},
	{
		"id": 662,
		"Jahr": 2001,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 386,
		"SozialhilfeQuote": 6.2
	},
	{
		"id": 663,
		"Jahr": 2002,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 444,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 664,
		"Jahr": 2003,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 478,
		"SozialhilfeQuote": 7.5
	},
	{
		"id": 665,
		"Jahr": 2004,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 595,
		"SozialhilfeQuote": 9.2
	},
	{
		"id": 666,
		"Jahr": 2005,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 782,
		"SozialhilfeQuote": 12
	},
	{
		"id": 667,
		"Jahr": 2006,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 777,
		"SozialhilfeQuote": 12
	},
	{
		"id": 668,
		"Jahr": 2007,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 692,
		"SozialhilfeQuote": 10.5
	},
	{
		"id": 669,
		"Jahr": 2008,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 697,
		"SozialhilfeQuote": 10.4
	},
	{
		"id": 670,
		"Jahr": 2009,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 622,
		"SozialhilfeQuote": 9
	},
	{
		"id": 671,
		"Jahr": 2010,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 588,
		"SozialhilfeQuote": 8.4
	},
	{
		"id": 672,
		"Jahr": 2011,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 613,
		"SozialhilfeQuote": 8.9
	},
	{
		"id": 673,
		"Jahr": 2012,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 591,
		"SozialhilfeQuote": 8.6
	},
	{
		"id": 674,
		"Jahr": 2013,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 591,
		"SozialhilfeQuote": 8.5
	},
	{
		"id": 675,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"SozialhilfeBeziehende": 628,
		"SozialhilfeQuote": 8.7
	},
	{
		"id": 676,
		"Jahr": 2000,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 736,
		"SozialhilfeQuote": 7.5
	},
	{
		"id": 677,
		"Jahr": 2001,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 662,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 678,
		"Jahr": 2002,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 658,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 679,
		"Jahr": 2003,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 768,
		"SozialhilfeQuote": 8
	},
	{
		"id": 680,
		"Jahr": 2004,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 883,
		"SozialhilfeQuote": 9.2
	},
	{
		"id": 681,
		"Jahr": 2005,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 1003,
		"SozialhilfeQuote": 10.4
	},
	{
		"id": 682,
		"Jahr": 2006,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 1140,
		"SozialhilfeQuote": 11.6
	},
	{
		"id": 683,
		"Jahr": 2007,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 1147,
		"SozialhilfeQuote": 11.5
	},
	{
		"id": 684,
		"Jahr": 2008,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 1034,
		"SozialhilfeQuote": 10.3
	},
	{
		"id": 685,
		"Jahr": 2009,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 992,
		"SozialhilfeQuote": 9.8
	},
	{
		"id": 686,
		"Jahr": 2010,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 943,
		"SozialhilfeQuote": 9.2
	},
	{
		"id": 687,
		"Jahr": 2011,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 896,
		"SozialhilfeQuote": 8.8
	},
	{
		"id": 688,
		"Jahr": 2012,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 902,
		"SozialhilfeQuote": 8.8
	},
	{
		"id": 689,
		"Jahr": 2013,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 919,
		"SozialhilfeQuote": 8.8
	},
	{
		"id": 690,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"SozialhilfeBeziehende": 895,
		"SozialhilfeQuote": 8.5
	},
	{
		"id": 691,
		"Jahr": 2000,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 616,
		"SozialhilfeQuote": 5.7
	},
	{
		"id": 692,
		"Jahr": 2001,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 543,
		"SozialhilfeQuote": 5
	},
	{
		"id": 693,
		"Jahr": 2002,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 608,
		"SozialhilfeQuote": 5.5
	},
	{
		"id": 694,
		"Jahr": 2003,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 740,
		"SozialhilfeQuote": 6.8
	},
	{
		"id": 695,
		"Jahr": 2004,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 877,
		"SozialhilfeQuote": 8.1
	},
	{
		"id": 696,
		"Jahr": 2005,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 1057,
		"SozialhilfeQuote": 9.8
	},
	{
		"id": 697,
		"Jahr": 2006,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 1046,
		"SozialhilfeQuote": 9.9
	},
	{
		"id": 698,
		"Jahr": 2007,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 967,
		"SozialhilfeQuote": 9
	},
	{
		"id": 699,
		"Jahr": 2008,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 905,
		"SozialhilfeQuote": 8.3
	},
	{
		"id": 700,
		"Jahr": 2009,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 860,
		"SozialhilfeQuote": 7.7
	},
	{
		"id": 701,
		"Jahr": 2010,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 872,
		"SozialhilfeQuote": 8
	},
	{
		"id": 702,
		"Jahr": 2011,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 930,
		"SozialhilfeQuote": 8.4
	},
	{
		"id": 703,
		"Jahr": 2012,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 926,
		"SozialhilfeQuote": 8.5
	},
	{
		"id": 704,
		"Jahr": 2013,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 908,
		"SozialhilfeQuote": 8.5
	},
	{
		"id": 705,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"SozialhilfeBeziehende": 856,
		"SozialhilfeQuote": 7.7
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/components/svgQuarterMap/data/zhQuarterMapSoziahilfe.json
// module id = 258
// module chunks = 0